import {EntityType} from "../../../gd/const/item"

// The `relatedItems` payload delivers the item data in one bucket per entity
// type (`tasks`, `projects`, ...), while a relation row points at its two items
// by type + id. This is the phone book between the two: give it a type and an
// id, it gives back that item's json.
//
// Only the OTHER items are in there -- the item being viewed is never sent, you
// are looking at it.
export default class RelatedItemsJson {

    private itemsByKey: {[key: string]: any} = {}

    constructor(relatedItems: any) {
        this.addBucket(EntityType.TASK,     relatedItems.tasks)
        this.addBucket(EntityType.PROJECT,  relatedItems.projects)
        this.addBucket(EntityType.EVENT,    relatedItems.events)
        this.addBucket(EntityType.MEETING,  relatedItems.meetings)
        this.addBucket(EntityType.DOCUMENT, relatedItems.documents)
        this.addBucket(EntityType.USER,     relatedItems.users)
        this.addBucket(EntityType.GOAL,     relatedItems.goals)
    }

    // Ids are unique per entity type only, so the key needs both.
    private key(itemType: EntityType, itemId: ID): string {
        return `${itemType}:${itemId}`
    }

    private addBucket(itemType: EntityType, bucket: any[]) {
        _.each(bucket || [], (json: any) => {
            this.itemsByKey[this.key(itemType, json.id)] = json
        })
    }

    get(itemType: EntityType, itemId: ID): any {
        return this.itemsByKey[this.key(itemType, itemId)]
    }
}
